<template>
    <div class="d-flex flex-column parent-survey-main-container bg-white">
        <div class="parent-survey-header">
            <nav-title :color="false" :customClass="'bg-white'"/>
            <nav-subtitle :title="'Survey List'" :icon="'content_paste'" :customClass="'pt-3 pb-4'"/>
        </div>
        <empty-module
            v-if="parentSurveys.length == 0"
            :title="'The app admin has not yet uploaded any surveys'"
            :icon="'content_paste '"
        />
        <div class="parent-survey-list d-flex flex-column overflow-auto px-3 py-4">
            <survey-card 
            :customClass="'mb-3'"
            v-for="(survey,index) in parentSurveys" 
            :survey="survey"
            :key="survey.id +''+index"/>
         
        </div>
    </div>
</template>

<script>
import navTitle from "@/components/general/navTitle.vue";
import navSubtitle from "@/components/general/navSubtitle.vue";
import emptyModule from "@/components/general/emptyModule.vue";
import surveyCard from "./surveyCard.vue";
import { mapActions, mapGetters } from "vuex";

export default ({
    components: {
        navTitle,
        navSubtitle,
        surveyCard,
        emptyModule
    },
    computed: {
        ...mapGetters("surveys", ["getParentSurveys"])
    },
    data() {
        return {
            parentSurveys:[]
        }
    },
    mounted(){
        this.fetchParentSurveys().then(()=>{
            this.parentSurveys = this.getParentSurveys
        })
    },
    methods: {
    ...mapActions("surveys", ["fetchParentSurveys"]),
  },
})
</script>

<style lang="scss">
.parent-survey-main-container{
    background-color: #ffffff;
    .parent-survey-header{
        box-shadow: 0px 3px 6px #00000029;
    }

    .parent-survey-list{
        flex: 1;
    }
}
</style>
